import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Role, AppRoles, AvailableAppRoles } from '@app/_models';

import { AccountService } from '@app/_services';
import { PortalCardsComponent } from './portal-cards/portal-cards.component';

@Component({
    templateUrl: 'home.component.html',
    styleUrls: ['home.component.css'],
    standalone: true,
    imports: [PortalCardsComponent]
})
export class HomeComponent implements OnInit {
    account = this.accountService.accountValue;
    appRoles = [];
    availableAppRoles = [];
    demoRoles = [];

    constructor(
        private accountService: AccountService,
        private router: Router
    ) {
        const passthrough = this.account.passthroughPortalAppId;
        if (passthrough) {
            if (passthrough === 1) {
                this.router.navigate(['/precise']);
            } else if (passthrough === 2) {
                this.router.navigate(['/dxpro']);
            } else if (passthrough === 3) {
                this.router.navigate(['/vennhealth']);
            } else if (passthrough === 4) {
                this.router.navigate(['/predict']);
            } else if (passthrough === 5) {
                this.router.navigate(['/countyfips']);
            } else if (passthrough === 6) {
                this.router.navigate(['/biomarkers']);
            }
        }
     }

    ngOnInit(): void {
        const allAppRoleEnums = Object.values(AppRoles);
        this.appRoles = allAppRoleEnums.filter(function (e) {
            return typeof e !== 'string';
        });
        const availableAppRoleEnums = Object.values(AvailableAppRoles);
        this.availableAppRoles = availableAppRoleEnums.filter(function (e) {
            return typeof e !== 'string';
        });
    }

    hasApplicationRoles(): boolean {
        if (this.account.roles.length === 0 || 
            (!this.account.roles.some(i => this.appRoles.includes(i)) && 
             !this.account.roles.includes(Role.Admin))) {
            return false;
        }
        return true;
    }

    hasAvailableApplications(): boolean {
        if (!this.availableAppRoles.some(i => this.account.roles.includes(i)) || 
            this.account.roles.includes(Role.Admin)) {
            return false;
        }
        return true;
    }

    isInRole(roleId: number) {
        return this.account.roles.includes(roleId);
    }


}